import { NudgeTypes } from '../constants';
export const Definition = {
  selector: `[data-nudge-type="${NudgeTypes.CALLOUT}"]`,
  shouldTrackRenderedForChild: () => {
    return true;
  },
  shouldTrackDismissedForChild: () => {
    return true;
  },
  getNudgeProperties: () => {
    return {
      type: NudgeTypes.CALLOUT,
      title: 'Callout'
    };
  }
};